import { z } from 'zod'

import {
  broadbandPlanBaseSchema as _broadbandPlanBaseSchema,
  broadbandPlanMemberSchema as _broadbandPlanMemberSchema,
  speedRestrictionSchema,
} from '@giffgaff/broadband-common'

import { ecommerceBaseProductSchema } from './ecommerce.schemas'

const speedRestrictionExtension = { speedRestriction: speedRestrictionSchema.optional() }

export const broadbandPlanBaseSchema = _broadbandPlanBaseSchema.extend(speedRestrictionExtension)
export const broadbandPlanMemberSchema = _broadbandPlanMemberSchema.extend(speedRestrictionExtension)

export const changePlanPreviewSchema = z.object({
  changeType: z.enum(['UPGRADE', 'DOWNGRADE']),
  currentEcommerceOrderScheduleId: z.string().uuid().optional(),
  newContractRequired: z.boolean().optional().default(false),
  newPlan: ecommerceBaseProductSchema,
  oldPlan: ecommerceBaseProductSchema.nullish().transform(x => x ?? undefined),
  ongoingPriceNewPlan: z.string(),
  paymentRequired: z.boolean().optional().default(true),
})
